import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {Toast} from '@/store/toast/toast.types';
import {MemberInitState} from '@/store/member/member.types';
import {FileType, ReferenceID} from '@/store/files/files.types';
import {
  Invite,
  ServiceFormSearch,
  ServiceSearchResultComponentInterface,
  ServiceSearchResultInterface
} from '@/class/service-form.interface';
import {BaseDocument} from '@/store/type';
import VisitViewComponent from '@/components/profile/visitor-view.vue';
import {Community, CommunityInitState, FilterCommunity} from '@/store/community/community.types';
import {Branch, BranchInitState} from '@/store/branch/branch.types';

@Component({
  components: {
    VisitViewComponent
  }
})
export default class ServiceSearchResultComponent extends Vue implements ServiceSearchResultComponentInterface {
  @State('branch') branchInitState!: BranchInitState;
  @State('community') communityInitState!: CommunityInitState;
  @State('member') memberState!: MemberInitState;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_getFiles', {namespace: 'file'}) getFiles!: (payload: ReferenceID) => Promise<any>;
  @Action('_setInviteList', {namespace: 'member'}) setInviteList!: (payload: Invite[]) => Promise<any>;
  @Action('_setVisitorId', {namespace: 'member'}) setVisitorId!: (id: string) => void;
  @Action('_getCommunity', {namespace: 'community'}) getCommunity!: (filter?: FilterCommunity) => Promise<void>;
  @Action('_getBranchForRegister', {namespace: 'branch'}) getBranchForRegister!: () => Promise<void>;


  public communityList = [{id: ''}] as Community[];
  public branchList = [{id: ''}] as Branch[];
  public serviceFormSearch = {} as ServiceFormSearch;
  public searchResultList = [] as ServiceSearchResultInterface[];
  public inviteList = [{}] as Invite[];
  public isVisitorClick: boolean = false;

  async mounted() {
    await this.getBranchForRegister();
    this.branchList = this.branchInitState.branchs;
    await this.getCommunity()
    this.communityList = this.communityInitState.community
    this.fetchResult().then(() => {
      // this.searchResultList = [{
      //   address:'sdfjlsdfjk'
      // }] as any;
    });
  }

  async fetchResult() {
    this.serviceFormSearch = this.memberState.serviceFormSearch;
    if (this.memberState.getMemberFromService.length) {
      this.searchResultList = this.memberState.getMemberFromService.map((res) => {
        // @ts-ignore
        let branch = this.branchList.find((x) => x.id === res.branchId)
        let community = this.communityList.find((x) => x.id === res.communityId)
        return {
          id: res.id || '',
          firstName: res.firstName,
          lastName: res.lastName,
          select: false,
          address: res.currentAddress,
          profile: res.profile,
          branch: branch ? branch.branchName : '-',
          community: community ? community.communityName : '-',
          image: 'https://fakeimg.pl/150x150/?retina=1&text=Img&font=noto',
          lineId: res.lineId,
          mobilePhone: res.mobilePhone
        }
      });

      console.log(this.searchResultList)
      // this.searchResultList[0].select = true;
    }
    this.getProfile();
  }

  getProfile() {
    this.searchResultList.forEach((row) => {
      this.getFiles({
        private: true,
        fileType: FileType.original,
        refId: row.profile
      }).then((res: any[]) => {
        if (res.length) {
          console.log('DEBUG: res[0].filePath', res[0].filePath);
          row.image = res[0].filePath;
        }
      })

    })
  }

  countSelect() {
    let filter = this.searchResultList.filter((row) => {
      return row.select ? row.select : null;
    });
    return filter.length
  }

  searchMoreClick() {
    this.$router.push('/service-search').then();
  }

  searchResultClick(e: number) {
    setTimeout(() => {
      if (this.isVisitorClick) {
        //เข้าโหมด visitor (view profile)
        return;
      }
      if (this.searchResultList[e].select) {
        this.searchResultList[e].select = false;
      } else if (this.countSelect() < 3) {
        this.searchResultList[e].select = true;
      } else {
        this.Toast({
          heading: '!',
          message: 'คุณเลือกเกินจำนวนที่กำหนด',
          type: 'warning'
        }).then();

      }
    }, 50);
  }

  clickVisitor(e: ServiceSearchResultInterface) {
    this.setVisitorId(e.id);
    this.isVisitorClick = true;
    this.$bvModal.show('my-modal');
  }

  close() {
    this.isVisitorClick = false;
    this.$bvModal.hide('my-modal');
  }

  async inviteClick() {
    if (this.countSelect() < 1) {
      this.Toast({
        heading: '!',
        message: 'ต้องเลือกอย่างน้อย 1 รายการ',
        type: 'danger'
      }).then();
      return;
    }
    let filter = this.searchResultList.filter((row) => {
      return row.select ? row.select : null;
    });

    this.inviteList = filter.map((row): Invite => {
      return {
        inviteId: row.id,
        subServiceId: this.serviceFormSearch.subServiceId,
        serviceType: this.serviceFormSearch.serviceType
      } as Invite
    });
    await this.setInviteList(this.inviteList);
    this.$emit('invited', this);
  }
};

